import { render, staticRenderFns } from "./DeliveryDetailView.vue?vue&type=template&id=35aa21f1&scoped=true&lang=pug"
import script from "./DeliveryDetailView.vue?vue&type=script&lang=js"
export * from "./DeliveryDetailView.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDetailView.vue?vue&type=style&index=0&id=35aa21f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aa21f1",
  null
  
)

export default component.exports